import React,{ Component } from "react";
import {IsPC,IsPcChild} from '../../components/IsPc'
import PC from './PC/index'
import Mobile from './Mobile/index'
class Index extends Component{
    componentDidMount() {

    }
    render() {
        return (
            <div style={{width:'100%',height:'100%'}}>
                <IsPcChild  IsPC={IsPC()} >{/*pc端*/}
                    <PC />
                </IsPcChild>
                <IsPcChild  IsPC={!IsPC()} >{/*手机端*/}
                    <Mobile />
                </IsPcChild>
            </div>
        );
    }
}
export default Index